import {
  inventory_target_overall,
  inventory_target_cluster,
  inventory_target_area,
  inventory_target_branch,
} from "../../services/reports/inventory_target_service";
import { actionTypes } from "../action_types";

const defaultData = { monthlyTargetSummaries: [] };

const createInventoryTargetAction = (fetchFunction, actionType) => (data) => (dispatch) => {
  return fetchFunction(data).then((resp) => {
    if (resp.problem === null) {
      dispatch({
        type: actionType,
        payload: resp.data !== null ? resp.data : defaultData,
      });
    }
    return Promise.resolve(resp);
  });
};

export const GetInventoryTargetOverall = createInventoryTargetAction(
  inventory_target_overall,
  actionTypes.REPORTS_INVENTORY_TARGET_GET_OVERALL
);

export const GetInventoryTargetCluster = createInventoryTargetAction(
  inventory_target_cluster,
  actionTypes.REPORTS_INVENTORY_TARGET_GET_CLUSTER
);

export const GetInventoryTargetArea = createInventoryTargetAction(
  inventory_target_area,
  actionTypes.REPORTS_INVENTORY_TARGET_GET_AREA
);

export const GetInventoryTargetBranch = createInventoryTargetAction(
  inventory_target_branch,
  actionTypes.REPORTS_INVENTORY_TARGET_GET_BRANCH
);
